/**
 *  TÖMEGES ÉRTÉKELÉS – közös logika a naplónak és az Értékelések menünek.
 *
 *  Ugyanaz a névsor-szerkezet van mindkét helyen (`kivalasztottOra.osztaly_nevsor`),
 *  ezért a kitöltés is közös: két külön megvalósítás előbb-utóbb elcsúszna egymástól,
 *  és a tanár azt tapasztalná, hogy a napló másképp viselkedik, mint az Értékelések.
 *
 *  Az értékelés TÍPUSÁHOZ nem nyúlunk: azt a fenti választó adja, tehát a tömeges
 *  kitöltés minden típusnál (dolgozat, felelet, óraiIkm stb.) ugyanúgy működik.
 */

/** Kire írjunk: mindenkire, vagy csak akinek még nincs értéke. */
export type TomegesHatokor = 'mind' | 'ures';

/** A névsorban használt értékmező. Fokozat-módban a szorgalom külön mező. */
export type TomegesMezo = 'osztalyzat' | 'szorgalomodost';

function uresE(v: any): boolean {
  return v === null || v === undefined || String(v).trim() === '';
}

/**
 *  Beírja az értéket a névsor sorai közé, és visszaadja, hány sort érintett.
 *
 *  A darabszám nem díszítés: tömeges műveletnél a tanárnak látnia kell, hogy tényleg
 *  arra a körre ment, amire szánta – „mindenki" és „csak az üresek" között könnyű
 *  melléfogni.
 */
export function tomegesErtekeles(
  nevsor: any[], ertek: any, hatokor: TomegesHatokor = 'mind', mezo: TomegesMezo = 'osztalyzat',
): number {
  if (!Array.isArray(nevsor)) return 0;
  let db = 0;
  for (const tanulo of nevsor) {
    if (!tanulo) continue;
    if (hatokor === 'ures' && !uresE(tanulo[mezo])) continue;
    tanulo[mezo] = ertek;
    db++;
  }
  return db;
}

/** Hányan vannak még érték nélkül – a gomb feliratához. */
export function uresekSzama(nevsor: any[], mezo: TomegesMezo = 'osztalyzat'): number {
  if (!Array.isArray(nevsor)) return 0;
  return nevsor.filter((t) => t && uresE(t[mezo])).length;
}
